module.exports = __webpack_public_path__ + "static/img/loginBg1.cd3490d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginBg1.png
// module id = oomT
// module chunks = 1